export const PERMISSION_KEYS = [
  'canViewDashboard',
  'canViewTeachers',
  'canAddTeachers',
  'canEditTeachers',
  'canDeleteTeachers',
  'canViewAttendance',
  'canEditAttendance',
  'canApproveMovement',
  'canExportReports',
  'canViewFees',
  'canEditFees',
  'canViewFeedingFee',
  'canEditFeedingFee',
  'canManageAdmins',
];

export const PERMISSION_LABELS = {
  canViewDashboard: 'View dashboard',
  canViewTeachers: 'View teachers',
  canAddTeachers: 'Add teachers',
  canEditTeachers: 'Edit teachers',
  canDeleteTeachers: 'Delete teachers',
  canViewAttendance: 'View attendance',
  canEditAttendance: 'Edit attendance',
  canApproveMovement: 'Approve movement',
  canExportReports: 'Export reports',
  canViewFees: 'View fees',
  canEditFees: 'Edit fees',
  canViewFeedingFee: 'View feeding fee',
  canEditFeedingFee: 'Edit feeding fee',
  canManageAdmins: 'Manage admins',
};

export const buildPermissions = (value = false) =>
  PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = value;
    return acc;
  }, {});

export const normalizePermissions = (permissions = {}) =>
  PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = Boolean(permissions?.[key]);
    return acc;
  }, {});

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getEffectivePermissions = (user = getStoredUser()) => {
  if (!user) return buildPermissions(false);
  if (user.role === 'superadmin') return buildPermissions(true);
  if (user.role === 'admin' && user.isPrimaryAdmin === true) return buildPermissions(true);
  if (user.role === 'admin' && !user.permissionsConfigured) return buildPermissions(true);
  return normalizePermissions(user.permissions);
};

export const hasPermission = (permissionName, user = getStoredUser()) => {
  if (!PERMISSION_KEYS.includes(permissionName)) return false;
  return Boolean(getEffectivePermissions(user)[permissionName]);
};

export const canAccessAny = (permissionNames = [], user = getStoredUser()) =>
  permissionNames.some((permissionName) => hasPermission(permissionName, user));

export const getDefaultDashboardPath = (user = getStoredUser()) => {
  if (!user) return '/login';
  if (user.role === 'superadmin') return '/super-admin/dashboard';
  if (hasPermission('canViewDashboard', user)) return '/dashboard';
  if (hasPermission('canViewTeachers', user)) return '/dashboard/teachers';
  if (hasPermission('canViewAttendance', user)) return '/dashboard/attendance';
  if (hasPermission('canExportReports', user)) return '/dashboard/sba-records';
  if (hasPermission('canViewFees', user)) return '/dashboard/fees';
  if (hasPermission('canViewFeedingFee', user)) return '/dashboard/feeding-fees';
  if (hasPermission('canManageAdmins', user)) return '/dashboard/admins';
  return '/dashboard';
};
